import Vue from 'vue'
import Router from 'vue-router'
import routers from './router'
import Util from '@/lib/util'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  if (originalPush.call(this, location)) {
    return originalPush.call(this, location).catch(err => err)
  }
}
Vue.use(Router)
// 路由配置
const RouterConfig = {
  mode: 'history',
  routes: routers
}

const router = new Router(RouterConfig)
router.beforeEach((to, from, next) => {
  Util.setTitle(to.meta.title)
  next()
})
router.afterEach((to, from) => {
  window.scrollTo(0, 0)
  window.eda.Init({
    $from_path: from, // 固定填‘from’来源,单页面必填(不填会引起收集数据错误)
    $to_path: to, // 固定填‘to’目标,单页面必填(不填会容易引起收集数据错误)
    $appid: '100009', // sdk平台分配的接口app编号(必填)
    $token: 'gwcdwebappkey#!', // sdk平台分配的接口app秘钥(必填)
    $source_platform: '4',
    $project_name: 'eda_project_06', // sdk平台分配项目名称默认default
    $heat_map: {} // 自动埋点点击事件配置
  })
})
export default router
